import React from 'react';

var classNames = require('classnames');

function QED(props) {

    return (
        <table className='table  table-responsive table-hover' style={{cursor:'default'}} {...props} >
            {props.children}
        </table>
    );
}


QED.Columns = function(props) {


    let renderColumn = (column, index) => {
        if (typeof column == 'function')
            column = column(index);

        return React.cloneElement(column, {key:index, column:index});
    }

    let renderColumns = (columns) => {

        return columns.map((column, index) => {
            return renderColumn(column, index);
        });
    }

    var {columns, ...props} = props;

    return (
        <thead>
            <tr {...props}>
                {renderColumns(columns)}
            </tr>
        </thead>
    );
}

QED.Column = function(props) {

    return (
        <th {...props}>
            {props.children}
        </th>

    );
}


QED.Cell = function(props) {

    return (
        <td {...props}>
            {props.children}
        </td>

    );
}

QED.Row = function(props) {

    return (
        <tr {...props}>
            {props.children}
        </tr>
    );

}


QED.Rows = function(props) {

    var {rows, ...props} = props;

    let renderCell = (cell, rowIndex, columnIndex) => {

        if (typeof cell == 'function')
            cell = cell(rowIndex, columnIndex);

        return React.cloneElement(cell, {key:columnIndex, row:rowIndex, column:columnIndex});
    }

    let renderRow = (row, rowIndex) => {

        let html = row.map((cell, columnIndex) => {
            return renderCell(cell, rowIndex, columnIndex);
        });

        return (
            <tr key={rowIndex} row={rowIndex}>
                {html}
            </tr>
        );
    };

    let html = rows.map((row, rowIndex) => {
        return renderRow(row, rowIndex);
    });


    return (
        <tbody {...props}>
            {html}
        </tbody>
    );

}



export default QED;